import { useEffect, useState } from "react";
import { Badge, Box } from "@chakra-ui/react";
import Card from "components/card";
import PreloaderSpinner from "components/PreloaderSpinner";
import { config } from "variables/config";
import useDataFetching from "hooks/useDataFetching";
import { useAuthHeader, useAuthUser } from "react-auth-kit";
import axios from "axios";
import { checkIsValidPermit } from "utils";
import {
  BsArrowBarLeft,
  BsArrowRight,
  BsArrowRightCircle,
  BsArrowRightCircleFill,
  BsChatLeft,
  BsFiletypeXlsx,
  BsPersonFill,
  BsPlusCircle,
  BsSearch,
  BsThreeDotsVertical,
  BsXCircle,
} from "react-icons/bs";
import MButton from "components/Mbutton";
import SearchModal from "components/SearchModal";
import { formatNumber } from "utils";
import MuiTable from "components/MuiTable";

import { ButtonGroup, Chip, Typography, capitalize } from "@mui/material";
import MuiAUtocomplete from "components/MuiAutocomplete";
import MuiSelect from "components/MuiSelect";
import MuiDatePicker from "components/MuiDatePicker";
import { ENTRY_TYPE } from "Constaints";
import { formatDate } from "utils";
import { getLastContract } from "utils";
import { useLocation, useNavigate, useNavigation } from "react-router-dom";
import { checkIsValidContractDate } from "utils";
import ReportModalInfos from "./ReportModalInfos";
import { getReportHeaders } from "Constaints";
import StatsCard from "./StatsCard";
import PaginateBox from "components/PaginateBox";
import AddRepport from "./AddRepport";
import { useTranslation } from "react-i18next"; // Importez useTranslation

const Reports = ({ compact }) => {
  const { t } = useTranslation("reports"); // Utilisez le hook useTranslation avec le namespace 'reports'

  const auth = useAuthUser();
  const authHeader = useAuthHeader();

  const [searchTerm, setSearchTerm] = useState(null);
  const [selectedReportployer, setselectedReportployer] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const [creator, setCreator] = useState(null);

  const [reports, setreports] = useState([]);
  const [loading, setLoading] = useState(false);
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");
  const [expired, setExpired] = useState("");
  const [selectedEnterprise, setSelectedEnterprise] = useState("");

  const [params, setParams] = useState({
    start: location.state?.start,
    end: location.state?.end,
    isValidated: location.state?.isValidated,
    page: 0,
    limit: 50,
    creatorId: location?.state?.creator?.id,
  });

  const [loadingU, errorU, agents, fetchDataU] = useDataFetching(
    `${config.app.api_url}/roles/3/users`
  );

  useEffect(() => {
    if (location.state) {
      setCreator(location?.state?.creator);
      setParams({
        start: location.state?.start,
        end: location.state?.end,
        isValidated: location.state?.isValidated,
        page: 0,
        limit: 50,
        creatorId: location?.state?.creator?.id,
      });
    }
  }, [location]);

  const getReports = () => {
    setLoading(true);
    const rr = Object.keys(params)?.map((key) => {
      return params[key] != null && params[key] != undefined
        ? key + "=" + params[key]
        : "-1";
    });
    const tt = rr?.filter((r) => r !== "-1")?.join("&");
    axios
      .get(`${config.app.api_url}/reports/query?${tt}`, {
        headers: {
          Authorization: authHeader(),
        },
      })
      .then((res) => {
        setreports(res?.data?.data);
      })
      .catch((err) => {
        console.log(err);
        setreports([]);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    getReports();
  }, [params]);

  const [open, setOpen] = useState(false);
  const [selectedReport, setSetselectedReport] = useState("");

  const handleClick = (item) => {
    if (item) {
      setSetselectedReport(item);

      setOpen(true);
    }
  };

  // Les en-têtes de table seront traduits directement par REPORT_HEADER si c'est un objet
  // ou devront être définis ici et traduits un par un.
  // Pour l'instant, je les laisse si REPORT_HEADER est déjà géré ailleurs.
  // Si REPORT_HEADER est un tableau de chaînes littérales, il faudra le modifier pour utiliser t()
  const headerTable = [
    t("full_names"),
    t("gender"),
    t("enterprise"),
    t("position"),
    t("salary"),
    t("nationality"),
    t("passport_number"),
    t("permit_number"),
    t("permit_expiration_date"),
    t("permit_status"),
  ];

  const handleRestFilter = () => {
    setParams({
      start: "",
      end: "",
      visaExpired: "",
      isValidated: "",
    });

    setStart("");
    setEnd("");
  };

  function createData(
    N,
    Noms,
    Date,
    Title,
    Observations,
    Rating,
    Valide,
    Options
  ) {
    return {
      N,
      Noms,
      Date,
      Title,
      Observations,
      Rating,
      Valide,
      Options,
    };
  }
  const rows = reports?.content?.map((item, index) => {
    return {
      handleClick: () => handleClick(item),

      datas: createData(
        params?.page * params?.limit + (index + 1),
        item?.fullName,
        formatDate(item?.date),
        item?.title,
        formatDate(item?.createdAt),
        item?.rating ? item?.rating + "/5" : "--",
        item?.isValidated == false ? (
          <Chip
            color="error"
            variant="outlined"
            className="capitalize-none"
            label={capitalize(t("bad"))}
          />
        ) : item?.isValidated == true ? (
          <Chip
            className="capitalize-none"
            variant="outlined"
            color="success"
            label={t("good")}
          />
        ) : (
          <Chip
            className="capitalize-none"
            variant="outlined"
            color="warning"
            label={t("pending_verification")}
          />
        ),
        <MButton
          variant={"white"}
          style={{ borderRadius: 20 }}
          onClick={() => handleClick(item)}
        >
          {t("consult")}
        </MButton>
      ),
    };
  });
  const [isAddOpen, setIsAddOpen] = useState(false);
  return (
    <div>
      <ReportModalInfos
        get={getReports}
        open={open}
        setOpen={setOpen}
        selectedReport={selectedReport}
        handleClose={() => {
          setSetselectedReport(null);
          setOpen(false);
        }}
      />
      <AddRepport isOpen={isAddOpen} onClose={() => setIsAddOpen(false)} />

      <div className=" grid h-full grid-cols-1 gap-5">
        {creator && (
          <Box
            bg={"red.100"}
            boxShadow="lg"
            p={2}
            rounded={"md"}
            border="1px"
            borderColor="gray.200"
            className=" flex flex-wrap gap-1  items-end justify-center"
          >
            <span className="flex gap-2 ">
              <BsPersonFill size={20} className="text-blue-400" />
              {t("enterprises_collected_by")}
              <strong>
                {creator?.creator?.firstName} {creator?.lastName}
              </strong>
            </span>
          </Box>
        )}
        <div className={"w-full h-full p-4 rounded-0 bg-white"}>
          <div class="w-full flex justify-between text-start py-5">
            <h2 class="text-3xl font-extrabold text-gray-900 sm:text-4xl">
              {t("recent_reports")}
            </h2>

            {compact ? (
              <div className="flex items-center me-4 gap-4 hover:curso-pointer">
                <div className="flex items-center gap-2">
                  <Typography variant="h6">{t("add")}</Typography>{" "}
                  <BsPlusCircle
                    onClick={() => setIsAddOpen(true)}
                    className="text-primary"
                    color="primary"
                    size={40}
                  />
                </div>
                <div
                  className="flex items-center gap-2"
                  onClick={() => {
                    navigate("/admin/reports");
                  }}
                >
                  <Typography variant="h6">{t("see_more")}</Typography>{" "}
                  <BsArrowRightCircle
                    className="text-primary"
                    color="primary"
                    size={40}
                  />
                </div>
              </div>
            ) : (
              <Box
                bg={"rgba(255, 255, 255, 1)"}
                boxShadow="lg"
                p={2}
                rounded={"md"}
                borderColor="gray.200"
                className=" flex flex-wrap gap-1  items-end justify-end"
              >
                <MuiDatePicker
                  label={t("start_period")}
                  value={params?.start}
                  onChange={(newValue) => {
                    setParams({
                      ...params,
                      start: new Date(newValue)?.getTime(),
                    });
                  }}
                  wrapperClasses={"flex-1 filter-item anime slideLeft"}
                />

                <MuiDatePicker
                  value={params?.end}
                  label={t("end_period")}
                  onChange={(newValue) => {
                    setParams({
                      ...params,
                      end: new Date(newValue)?.getTime(),
                    });
                  }}
                  wrapperClasses={"flex-1 filter-item anime slideLeft"}
                />

                <MuiSelect
                  label={t("report_validated")}
                  emptyLabel={t("all")}
                  value={params?.visaExpired}
                  options={[
                    { value: false, label: t("no") },
                    { value: true, label: t("yes") },
                  ]}
                  onChange={(e) => {
                    setParams({
                      ...params,
                      visaExpired: e.target.value?.toString(),
                    });
                  }}
                  wrapperClasses={"flex-1 filter-item anime slideUp"}
                />

                {/* Select nationalities */}
                <MuiAUtocomplete
                  value={params?.creatorId}
                  label={t("select_agent")}
                  options={agents?.dada?.map((item) => {
                    return { value: item?.id, label: item?.firstName || item?.lastName };
                  })}
                  onChange={(e, item) => setParams({ creatorId: item?.value })}
                  wrapperClasses={"flex-1 filter-item anime slideRight"}
                />
              </Box>
            )}
          </div>
          <div className="flex justify-between ">
            <div>
              <strong>
                {t("total")}
                <Badge
                  fontSize={13}
                  rounded={5}
                  padding={1}
                  paddingInline={2}
                  colorScheme="green"
                  className="m-0 ms-2"
                >
                  {formatNumber(reports?.totalElements) || "--"}
                </Badge>
              </strong>
            </div>
          </div>

          <MuiTable
            hidePagiation={true}
            columns={getReportHeaders(t)} // <--- Passez la fonction 't' en argument ici
            loading={loading}
            limit={params?.limit}
            rows={rows}
            textEmpty={t("no_reports")}
          />
          {/* <MuiTableCollapse/> */}

          {!compact && (
            <PaginateBox
              total={reports?.totalElements}
              rowsPerPage={params?.limit}
              handleChangeRowsPerPage={(event) => {
                setParams({
                  ...params,
                  limit: parseInt(event.target.value),
                  page: 0,
                });
              }}
              page={params.page}
              count={reports?.totalPages - 1}
              handleChange={(event, value) => {
                setParams({ ...params, page: value });
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Reports;